/**
 * Handshake mechanism — parent sends TWIPOINT_PARENT_INIT to iframe
 * with exponential backoff retry: 100ms -> 200ms -> 400ms -> 800ms -> 1600ms -> 2000ms
 */
import { debugLog } from './utils';
export const sendHandshake = (iframe, config, logPrefix, retryCount = 0) => {
    const { maxRetries, retryDelay, debugMode, onHandshakeComplete, onHandshakeFailed } = config;
    const targetOrigin = new URL(iframe.src).origin;
    const widgetId = iframe.id;
    try {
        const iframeOrigin = iframe.contentWindow?.location?.origin;
        if (iframeOrigin && iframeOrigin === targetOrigin) {
            debugLog(debugMode, logPrefix, `Iframe ready (attempt ${retryCount + 1}), sending handshake to`, widgetId);
            iframe.contentWindow.postMessage({ type: 'TWIPOINT_PARENT_INIT', parentOrigin: window.location.origin, widgetId }, targetOrigin);
            if (onHandshakeComplete)
                onHandshakeComplete(widgetId, retryCount);
            return;
        }
    }
    catch {
        try {
            debugLog(debugMode, logPrefix, `Attempt ${retryCount + 1} - sending handshake to`, widgetId);
            iframe.contentWindow.postMessage({ type: 'TWIPOINT_PARENT_INIT', parentOrigin: window.location.origin, widgetId }, targetOrigin);
        }
        catch (postError) {
            debugLog(debugMode, logPrefix, `Attempt ${retryCount + 1} failed:`, postError.message);
        }
    }
    if (retryCount < maxRetries) {
        const delay = Math.min(retryDelay * Math.pow(2, retryCount), 2000);
        setTimeout(() => sendHandshake(iframe, config, logPrefix, retryCount + 1), delay);
    }
    else {
        debugLog(debugMode, logPrefix, `Max retries reached for`, widgetId);
        if (onHandshakeFailed)
            onHandshakeFailed(widgetId);
    }
};
